export class IEvents {
}
//# sourceMappingURL=events.js.map